<div class="login-page">
    <div class="login-wrapper">
        <div class="brand-section">
            <img src="copago-logo.png" alt="Copago Logo" class="brand-logo" />
            <p class="brand-subtitle">Tischreservierungen · Portal</p>
        </div>

        <div class="login-card">
            <div class="login-card-header">
                <mat-icon class="login-icon">login</mat-icon>
                <h1>Anmelden</h1>
            </div>

            <form class="login-form" (ngSubmit)="login()">
                <div class="form-group">
                    <label for="username">Benutzername</label>
                    <input id="username" name="username" type="text" [(ngModel)]="username"
                        placeholder="Benutzername eingeben" autocomplete="username" />
                </div>

                <div class="form-group password-group">
                    <label for="password">Passwort</label>

                    <div class="password-input-wrapper">
                        <input id="password" name="password" [type]="hidePassword ? 'password' : 'text'"
                            [(ngModel)]="password" placeholder="Passwort eingeben" autocomplete="current-password" />

                        <button type="button" class="password-toggle" (click)="togglePasswordVisibility()"
                            aria-label="Toggle password visibility">
                            <mat-icon>
                                {{ hidePassword ? 'visibility' : 'visibility_off' }}
                            </mat-icon>
                        </button>
                    </div>
                </div>

                <div class="error-message" *ngIf="error">
                    {{ error }}
                </div>

                <button type="submit" class="login-button">
                    Anmelden
                </button>
            </form>
        </div>
    </div>
</div>